import { render, staticRenderFns } from "./ConfirmController.vue?vue&type=template&id=2f87dedd&scoped=true&lang=pug"
import script from "./ConfirmController.vue?vue&type=script&lang=js"
export * from "./ConfirmController.vue?vue&type=script&lang=js"
import style0 from "./ConfirmController.vue?vue&type=style&index=0&id=2f87dedd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87dedd",
  null
  
)

export default component.exports